import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Row, Col, Checkbox } from "rsuite";
import { intersectionBy } from "lodash";

const ShowHideColumnModal = ({
  isShowHideColumn,
  setIsShowHideColumn,
  settingColumn,
  columns,
  allColumns,
  defaultColumns,
  title = "Show / hide columns",
  resetToDefault = true,
}) => {
  const [selectedColumns, setSelectedColumns] = useState(columns);

  const closeShowHideColumn = () => {
    setIsShowHideColumn(false);
  };

  const onColumnCheck = (column, dataKey) => (value, checked) => {
    if (checked) {
      // Add the column to selected columns
      const newSelectedColumns = [...selectedColumns, column];
      // Maintain original order by using intersectionBy to filter allColumns based on selected columns
      const orderedSelectedColumns = intersectionBy(
        allColumns,
        newSelectedColumns,
        "dataKey"
      );
      setSelectedColumns(orderedSelectedColumns);
    } else {
      setSelectedColumns(
        selectedColumns.filter((col) => col.dataKey !== dataKey)
      );
    }
  };

  const updateColumns = () => {
    settingColumn(selectedColumns);
    closeShowHideColumn();
  };

  const resetColumns = () => {
    if (resetToDefault && defaultColumns) {
      setSelectedColumns(defaultColumns);
    } else {
      // Fallback to first 7 columns if no default provided
      setSelectedColumns(allColumns.slice(0, 7));
    }
  };

  return (
    <Modal
      backdrop="static"
      size="lg"
      className="show-hide-column-modal"
      keyboard={false}
      open={isShowHideColumn}
      onClose={closeShowHideColumn}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          {allColumns.map((column) => {
            const { label, dataKey } = column;
            const checked = selectedColumns.find(
              (col) => col.dataKey === dataKey
            );
            return (
              <Col key={label} xs={8}>
                <div className="show-hide-cell">
                  <Checkbox
                    defaultChecked={!!checked}
                    value={dataKey}
                    checked={!!checked}
                    onChange={onColumnCheck(column, dataKey)}
                  >
                    {label}
                  </Checkbox>
                </div>
              </Col>
            );
          })}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={resetColumns} appearance="ghost">
          Reset
        </Button>
        <Button onClick={updateColumns} appearance="primary">
          Update table
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ShowHideColumnModal.propTypes = {
  isShowHideColumn: PropTypes.bool.isRequired,
  setIsShowHideColumn: PropTypes.func.isRequired,
  settingColumn: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  allColumns: PropTypes.array.isRequired,
  defaultColumns: PropTypes.array,
  title: PropTypes.string,
  resetToDefault: PropTypes.bool,
};

export default ShowHideColumnModal;
